import React from 'react';
import { Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Typography } from '@mui/material';

interface RowData {
  patientName: string;
  guardiansName: string;
  mrn: number;

}

interface SearchModalProps {
  open: boolean;
  handleClose: () => void;
  data: RowData[];
  cnicphone: any;
  sendMRN: (arg: number) => void;
}

const SearchModal: React.FC<SearchModalProps> = ({ open, handleClose, data, cnicphone, sendMRN }) => {
  return (
    <Modal open={open} onClose={handleClose} >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: open ? '10px' : '0',
        border: 'none',
        maxHeight: '300px',

        '&:focus': { border: 'none', outline: 'none' },
        /* Style scrollbar */

      }}>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
          <Typography sx={{ fontWeight: 'bold' }}>Searched list</Typography>
          <Typography>{cnicphone}</Typography>
        </Box>
        <Box sx={{
          overflowY: 'auto', maxHeight: 'calc(200px)', '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '6px',
          },
        }}>
          <TableContainer component={Paper} style={{ border: 'none' }}>
            <Table sx={{ textAlign: 'center' }}>
              <TableHead>
                <TableRow>
                  <TableCell>MRN</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Guardian Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f0f0f0', cursor: 'pointer' } }} onClick={() => sendMRN(row?.mrn)}>
                    <TableCell>{row.mrn}</TableCell>
                    <TableCell>{row.patientName}</TableCell>
                    <TableCell>{row.guardiansName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Modal>


  );
};

export default SearchModal;
